import React from "react";
import { connect } from "react-redux";
import { Content as Component, WellPosition } from "./Content";

interface State {
  simulation?: {
    DISPENSIBLE_SOLUTION?: string;
    DISPENSIBLE_VOLUME?: number;
    DISPENSIBLE_WELLS?: string[];
  };
  microplate?: {
    wellsContent?: Record<string, Record<string, number>>;
  };
}

interface OwnProps {
  isDispense?: boolean;
  [key: string]: unknown;
}
interface MapStateToProps {
  dispensibleSolution: string;
  dispensibleVolume: number;
  dispensibleWells: WellPosition[];
  wellsContent: Record<WellPosition, Record<string, number>>;
}

function mapStateToProps(
  state: State,
  ownProps: OwnProps
): OwnProps & MapStateToProps {
  const dispensibleSolution = state["simulation"]?.DISPENSIBLE_SOLUTION || "";
  let dispensibleVolume = state["simulation"]?.DISPENSIBLE_VOLUME || 0;
  let dispensibleWells = (state["simulation"]?.DISPENSIBLE_WELLS ||
    []) as WellPosition[];
  const wellsContent = (state["microplate"]?.wellsContent || {}) as Record<
    WellPosition,
    Record<string, number>
  >;

  if (dispensibleSolution === "dh2o") {
    const a1Content = wellsContent["A1"];
    const isA1NotEmpty = a1Content && Object.keys(a1Content).length > 0;

    if (!isA1NotEmpty) {
      dispensibleWells = [];
      dispensibleVolume = 0;
    }
  }

  return {
    ...ownProps,
    dispensibleSolution,
    dispensibleVolume,
    dispensibleWells,
    wellsContent,
  };
}

export const ContentRedux = connect(mapStateToProps)(Component);
